import { useContext, useRef } from 'react'
import type { KeyboardEvent } from 'react'
import styled from 'styled-components'

import { InputContext, Container } from './InputContext'
import type { InputProps } from './Input'

import { ReactComponent as SearchBlur } from '../../assets/ico/common/search/search_default.svg'
import { ReactComponent as SearchFocus } from '../../assets/ico/common/search/search_active.svg'

interface SearchInputProps extends InputProps {
  onSearch?: (e: HTMLInputElement) => void
}

function Inner({ value, defaultValue, placeholder, onChange, onSearch, ...props }: SearchInputProps) {
  const { isFocus, handleBlur, handleFocus, handleKeyDown } = useContext(InputContext)
  const inputRef = useRef<HTMLInputElement | null>(null)

  const handleSearch = () => {
    if (!inputRef.current) return

    onSearch?.(inputRef.current)
  }

  const handleKeyDownSearch = (e: KeyboardEvent<HTMLInputElement>) => {
    handleKeyDown(e)
    if (e.key === 'Enter') handleSearch()
  }

  return (
    <>
      <input
        ref={inputRef}
        defaultValue={defaultValue}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onKeyDown={handleKeyDownSearch}
        {...props}
      />
      <SearchSubmit onMouseDown={handleSearch}>{isFocus ? <SearchFocus /> : <SearchBlur />}</SearchSubmit>
    </>
  )
}

export function Search(props: SearchInputProps) {
  return (
    <Container>
      <Inner {...props} />
    </Container>
  )
}

const SearchSubmit = styled.button`
  appearance: none;
  width: 24px;
  height: 24px;
  border: none;
  background: none;
`

export type { SearchInputProps }
